<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#8D1339" opacity="1.000000" stroke="none" 
	d="
M0.999998,251.000000 
	C1.000000,171.978561 1.000000,92.957138 1.346902,13.564118 
	C5.805033,9.775348 9.935952,6.381246 14.002512,2.911709 
	C14.509581,2.479085 14.675829,1.646994 15.000000,1.000000 
	C139.354767,1.000000 263.709534,1.000000 388.450806,1.352881 
	C392.326660,5.620378 395.797546,9.551880 399.334381,13.423131 
	C399.682739,13.804410 400.435150,13.816533 401.000000,14.000000 
	C401.000000,93.688103 401.000000,173.376205 400.647827,253.439850 
	C396.820465,258.498871 393.127808,262.911926 387.213409,264.680634 
	C387.027405,264.736267 387.066071,265.543274 387.000000,266.000000 
	C263.311890,266.000000 139.623810,266.000000 15.557651,265.646729 
	C10.009871,261.630341 5.031178,257.804535 2.635224,251.579254 
	C2.500167,251.228363 1.563542,251.185989 0.999998,251.000000 
M257.530731,30.073103 
	C250.151978,39.097462 247.005798,49.590298 246.972778,61.088211 
	C246.924973,77.742851 246.977142,94.397903 247.040756,111.052574 
	C247.050903,113.705444 247.058960,116.411385 247.551056,119.000999 
	C251.696396,140.815613 268.358307,154.772507 290.910797,154.904816 
	C322.553955,155.090485 354.198975,154.956482 385.843201,154.946930 
	C386.971588,154.946579 388.099915,154.815292 389.436554,154.732056 
	C389.436554,141.960526 389.436554,129.434174 389.436554,116.318192 
	C355.727386,116.318192 322.351837,116.318192 288.467194,116.318192 
	C288.467194,109.444489 288.780273,103.133080 288.366180,96.869743 
	C288.046051,92.027229 289.944611,91.054413 294.388062,91.080872 
	C322.700226,91.249519 351.014008,91.177101 379.327179,91.132721 
	C386.382080,91.121658 388.997467,88.532234 389.072784,81.540520 
	C389.157074,73.713638 389.108795,65.885155 389.094940,58.057404 
	C389.051270,33.367584 369.754578,14.009552 345.011230,13.915257 
	C328.190094,13.851153 311.366943,13.763265 294.547516,13.947446 
	C280.291779,14.103554 267.860016,18.886164 257.530731,30.073103 
M223.778992,238.230362 
	C224.518494,237.129028 225.613220,236.123703 225.940994,234.911057 
	C228.453491,225.615906 231.343079,216.375580 233.051727,206.925873 
	C234.306366,199.987076 229.421478,195.128098 222.245499,194.971039 
	C213.924652,194.788925 205.596832,194.903381 197.272141,194.926315 
	C188.279251,194.951080 183.354218,198.669998 180.956543,207.244629 
	C176.837784,221.974228 172.738083,236.709152 168.649628,251.447174 
	C168.266663,252.827637 168.020889,254.246155 167.607803,256.116028 
	C170.573090,256.116028 173.099304,255.807755 175.519547,256.183014 
	C179.960602,256.871613 181.881775,255.247955 183.006714,250.822388 
	C186.199814,238.260651 189.868820,225.817230 193.533478,213.381165 
	C194.031143,211.692307 195.507019,209.053864 196.645203,208.992493 
	C204.028046,208.594406 211.442795,208.788330 219.402573,208.788330 
	C217.776886,214.847473 216.243576,220.091934 214.992432,225.402878 
	C214.248489,228.560852 212.525681,229.773697 209.349091,229.688156 
	C204.058182,229.545654 198.760635,229.649307 193.257782,229.649307 
	C192.104996,234.266235 191.002167,238.682999 189.809372,243.460129 
	C197.508850,243.460129 204.550598,244.001221 211.453018,243.254471 
	C215.506409,242.815948 219.338181,240.328949 223.778992,238.230362 
M92.489708,243.614212 
	C97.144356,243.614212 101.799004,243.614212 106.734116,243.614212 
	C107.819000,239.466171 108.862244,235.477341 110.126808,230.642303 
	C97.198807,230.642303 84.701973,230.642303 72.173141,230.642303 
	C72.950729,222.495529 73.982819,221.489700 80.856522,221.530655 
	C87.519730,221.570358 94.182800,221.631683 100.845985,221.675964 
	C113.905678,221.762772 115.241760,220.494110 116.058403,207.256699 
	C116.548233,199.316757 112.767532,194.969269 104.735336,194.765747 
	C96.244522,194.550613 87.741837,194.521927 79.250298,194.698349 
	C71.081856,194.868042 66.224442,198.717499 64.002815,206.551605 
	C62.051918,213.431000 60.233295,220.351822 58.535381,227.298126 
	C56.147354,237.067749 60.955563,243.329102 71.003632,243.540817 
	C77.830856,243.684692 84.662987,243.596176 92.489708,243.614212 
M301.518036,243.614441 
	C309.006775,243.598114 316.495544,243.595566 323.984222,243.562302 
	C336.042542,243.508743 342.435394,237.364975 342.977783,225.337524 
	C343.317078,217.813644 339.421295,213.240662 331.910583,212.881287 
	C326.265656,212.611176 320.597351,212.859024 314.940491,212.791138 
	C313.211792,212.770386 311.486481,212.467331 309.820923,212.299744 
	C309.538361,208.111588 311.466461,207.115723 314.681915,207.149750 
	C323.334717,207.241333 331.989960,207.236786 340.642090,207.117706 
	C341.934021,207.099930 344.057220,206.564499 344.353973,205.745850 
	C345.612305,202.274567 346.326752,198.606125 347.320587,194.692078 
	C334.239960,194.692078 321.923767,194.382172 309.631531,194.791687 
	C300.071289,195.110199 294.296387,202.659714 294.775360,213.042160 
	C295.136444,220.869675 300.264832,224.873138 310.099609,224.939148 
	C316.011902,224.978836 321.924652,224.946426 327.923859,224.946426 
	C327.051331,230.101776 327.051636,230.171127 322.579895,230.189835 
	C312.145081,230.233490 301.709991,230.203766 291.137665,230.203766 
	C290.065948,234.847565 289.107819,238.999329 288.037292,243.638031 
	C292.580444,243.638031 296.554138,243.638031 301.518036,243.614441 
M290.714844,208.120071 
	C291.385864,199.740982 287.489594,195.176468 279.052460,194.973022 
	C270.729767,194.772339 262.398468,194.904663 254.071045,194.929550 
	C245.884171,194.954025 240.856812,198.391968 238.463089,206.210556 
	C236.322983,213.200729 234.450684,220.292007 232.868027,227.429092 
	C230.729111,237.074768 235.370605,243.071823 245.285706,243.427444 
	C253.269470,243.713791 261.278931,243.687698 269.264130,243.418594 
	C277.788116,243.131348 282.672852,239.078384 284.975067,230.696625 
	C286.956482,223.482956 288.669342,216.195511 290.714844,208.120071 
M146.819641,184.230347 
	C148.781631,184.230347 150.743607,184.230347 152.776169,184.230347 
	C153.787140,179.949768 154.686905,176.140045 155.739166,171.684647 
	C151.575150,171.684647 147.955917,171.673996 144.336761,171.686722 
	C134.899246,171.719879 129.735031,175.553299 127.243958,184.461411 
	C122.456238,201.582321 117.702248,218.712692 112.938980,235.840454 
	C112.254059,238.303284 111.595329,240.773407 110.843895,243.536484 
	C115.887787,243.536484 120.193100,243.536484 124.894516,243.536484 
	C127.620979,233.634537 130.359863,223.727005 133.071808,213.812088 
	C133.805145,211.130981 134.646744,208.935760 138.157928,208.713593 
	C146.583145,208.180496 146.582214,208.041718 148.747925,199.815613 
	C149.125580,198.381165 149.404236,196.920654 149.777863,195.252289 
	C146.084213,195.049713 142.561050,194.856491 139.067215,194.664871 
	C139.446732,186.518051 140.530502,184.968582 146.819641,184.230347 
M168.392624,185.029999 
	C161.055542,185.409683 156.487900,188.763748 154.347763,196.206421 
	C150.029129,211.225113 145.997879,226.326492 141.875824,241.401367 
	C141.721130,241.967087 141.856125,242.612030 141.856125,243.645599 
	C145.086472,243.645599 148.078735,243.426086 151.024094,243.703995 
	C154.327087,244.015656 155.644882,242.724365 156.419083,239.538849 
	C158.184570,232.274429 160.387436,225.115341 162.453125,217.925110 
	C164.928192,209.309906 164.946625,209.322540 174.097000,209.139786 
	C174.898834,209.123764 175.697067,208.926300 176.650757,208.791336 
	C177.670334,204.350693 178.654709,200.063278 179.775223,195.182983 
	C175.877609,195.182983 172.607635,195.182983 169.005722,195.182983 
	C169.643311,192.234451 170.307922,189.832138 170.601746,187.385330 
	C170.687698,186.669495 169.718796,185.826981 168.392624,185.029999 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M0.999998,251.472656 
	C1.563542,251.185989 2.500167,251.228363 2.635224,251.579254 
	C5.031178,257.804535 10.009871,261.630341 15.089797,265.646729 
	C10.406250,266.000000 5.812500,266.000000 1.000000,266.000000 
	C1.000000,261.316559 1.000000,256.630951 0.999998,251.472656 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M14.525871,1.000000 
	C14.675829,1.646994 14.509581,2.479085 14.002512,2.911709 
	C9.935952,6.381246 5.805033,9.775348 1.346902,13.096265 
	C1.000000,9.070314 1.000000,5.140630 1.000000,1.000000 
	C5.349158,1.000000 9.700452,1.000000 14.525871,1.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M387.474121,266.000000 
	C387.066071,265.543274 387.027405,264.736267 387.213409,264.680634 
	C393.127808,262.911926 396.820465,258.498871 400.647827,253.907715 
	C401.000000,257.929688 401.000000,261.859375 401.000000,266.000000 
	C396.650848,266.000000 392.299530,266.000000 387.474121,266.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M401.000000,13.523338 
	C400.435150,13.816533 399.682739,13.804410 399.334381,13.423131 
	C395.797546,9.551880 392.326660,5.620378 388.918640,1.352881 
	C392.925995,1.000000 396.851959,1.000000 401.000000,1.000000 
	C401.000000,5.013896 401.000000,9.030287 401.000000,13.523338 
z"/>
<path fill="#FEFDFE" opacity="1.000000" stroke="none" 
	d="
M257.771179,29.807888 
	C267.860016,18.886164 280.291779,14.103554 294.547516,13.947446 
	C311.366943,13.763265 328.190094,13.851153 345.011230,13.915257 
	C369.754578,14.009552 389.051270,33.367584 389.094940,58.057404 
	C389.108795,65.885155 389.157074,73.713638 389.072784,81.540520 
	C388.997467,88.532234 386.382080,91.121658 379.327179,91.132721 
	C351.014008,91.177101 322.700226,91.249519 294.388062,91.080872 
	C289.944611,91.054413 288.046051,92.027229 288.366180,96.869743 
	C288.780273,103.133080 288.467194,109.444489 288.467194,116.318192 
	C322.351837,116.318192 355.727386,116.318192 389.436554,116.318192 
	C389.436554,129.434174 389.436554,141.960526 389.436554,154.732056 
	C388.099915,154.815292 386.971588,154.946579 385.843201,154.946930 
	C354.198975,154.956482 322.553955,155.090485 290.910797,154.904816 
	C268.358307,154.772507 251.696396,140.815613 247.551056,119.000999 
	C247.058960,116.411385 247.050903,113.705444 247.040756,111.052574 
	C246.977142,94.397903 246.924973,77.742851 246.972778,61.088211 
	C247.005798,49.590298 250.151978,39.097462 257.771179,29.807888 
M327.499542,64.130371 
	C333.924713,64.130371 340.349884,64.130371 346.927002,64.130371 
	C346.927002,59.580425 346.927002,55.670757 346.927002,51.227009 
	C345.081268,51.227009 343.460449,51.227013 341.839600,51.227009 
	C327.546326,51.226994 313.250824,51.071674 298.960419,51.273449 
	C286.292450,51.452320 287.863129,48.370903 288.071411,63.159233 
	C288.075073,63.416847 288.442871,63.669334 288.800812,64.130371 
	C301.262909,64.130371 313.881348,64.130371 327.499542,64.130371 
z"/>
<path fill="#FDFAFB" opacity="1.000000" stroke="none" 
	d="
M223.524323,238.496857 
	C219.338181,240.328949 215.506409,242.815948 211.453018,243.254471 
	C204.550598,244.001221 197.508850,243.460129 189.809372,243.460129 
	C191.002167,238.682999 192.104996,234.266235 193.257782,229.649307 
	C198.760635,229.649307 204.058182,229.545654 209.349091,229.688156 
	C212.525681,229.773697 214.248489,228.560852 214.992432,225.402878 
	C216.243576,220.091934 217.776886,214.847473 219.402573,208.788330 
	C211.442795,208.788330 204.028046,208.594406 196.645203,208.992493 
	C195.507019,209.053864 194.031143,211.692307 193.533478,213.381165 
	C189.868820,225.817230 186.199814,238.260651 183.006714,250.822388 
	C181.881775,255.247955 179.960602,256.871613 175.519547,256.183014 
	C173.099304,255.807755 170.573090,256.116028 167.607803,256.116028 
	C168.020889,254.246155 168.266663,252.827637 168.649628,251.447174 
	C172.738083,236.709152 176.837784,221.974228 180.956543,207.244629 
	C183.354218,198.669998 188.279251,194.951080 197.272141,194.926315 
	C205.596832,194.903381 213.924652,194.788925 222.245499,194.971039 
	C229.421478,195.128098 234.306366,199.987076 233.051727,206.925873 
	C231.343079,216.375580 228.453491,225.615906 225.940994,234.911057 
	C225.613220,236.123703 224.518494,237.129028 223.524323,238.496857 
z"/>
<path fill="#FCF8F9" opacity="1.000000" stroke="none" 
	d="
M91.991318,243.612885 
	C84.662987,243.596176 77.830856,243.684692 71.003632,243.540817 
	C60.955563,243.329102 56.147354,237.067749 58.535381,227.298126 
	C60.233295,220.351822 62.051918,213.431000 64.002815,206.551605 
	C66.224442,198.717499 71.081856,194.868042 79.250298,194.698349 
	C87.741837,194.521927 96.244522,194.550613 104.735336,194.765747 
	C112.767532,194.969269 116.548233,199.316757 116.058403,207.256699 
	C115.241760,220.494110 113.905678,221.762772 100.845985,221.675964 
	C94.182800,221.631683 87.519730,221.570358 80.856522,221.530655 
	C73.982819,221.489700 72.950729,222.495529 72.173141,230.642303 
	C84.701973,230.642303 97.198807,230.642303 110.126808,230.642303 
	C108.862244,235.477341 107.819000,239.466171 106.734116,243.614212 
	C101.799004,243.614212 97.144356,243.614212 91.991318,243.612885 
M101.837784,209.232132 
	C100.657066,208.701538 99.489090,207.748810 98.293442,207.712692 
	C92.841888,207.548050 87.379898,207.744446 81.926941,207.604980 
	C78.280678,207.511719 76.786659,209.096405 77.154884,212.985565 
	C84.285530,212.985565 91.377731,213.112701 98.456093,212.856934 
	C99.598717,212.815643 100.679771,211.070602 101.837784,209.232132 
z"/>
<path fill="#FCF9FA" opacity="1.000000" stroke="none" 
	d="
M301.022949,243.626236 
	C296.554138,243.638031 292.580444,243.638031 288.037292,243.638031 
	C289.107819,238.999329 290.065948,234.847565 291.137665,230.203766 
	C301.709991,230.203766 312.145081,230.233490 322.579895,230.189835 
	C327.051636,230.171127 327.051331,230.101776 327.923859,224.946426 
	C321.924652,224.946426 316.011902,224.978836 310.099609,224.939148 
	C300.264832,224.873138 295.136444,220.869675 294.775360,213.042160 
	C294.296387,202.659714 300.071289,195.110199 309.631531,194.791687 
	C321.923767,194.382172 334.239960,194.692078 347.320587,194.692078 
	C346.326752,198.606125 345.612305,202.274567 344.353973,205.745850 
	C344.057220,206.564499 341.934021,207.099930 340.642090,207.117706 
	C331.989960,207.236786 323.334717,207.241333 314.681915,207.149750 
	C311.466461,207.115723 309.538361,208.111588 309.820923,212.299744 
	C311.486481,212.467331 313.211792,212.770386 314.940491,212.791138 
	C320.597351,212.859024 326.265656,212.611176 331.910583,212.881287 
	C339.421295,213.240662 343.317078,217.813644 342.977783,225.337524 
	C342.435394,237.364975 336.042542,243.508743 323.984222,243.562302 
	C316.495544,243.595566 309.006775,243.598114 301.022949,243.626236 
z"/>
<path fill="#FDFCFC" opacity="1.000000" stroke="none" 
	d="
M290.607880,208.530365 
	C288.669342,216.195511 286.956482,223.482956 284.975067,230.696625 
	C282.672852,239.078384 277.788116,243.131348 269.264130,243.418594 
	C261.278931,243.687698 253.269470,243.713791 245.285706,243.427444 
	C235.370605,243.071823 230.729111,237.074768 232.868027,227.429092 
	C234.450684,220.292007 236.322983,213.200729 238.463089,206.210556 
	C240.856812,198.391968 245.884171,194.954025 254.071045,194.929550 
	C262.398468,194.904663 270.729767,194.772339 279.052460,194.973022 
	C287.489594,195.176468 291.385864,199.740982 290.607880,208.530365 
M252.117996,209.461899 
	C250.281738,215.710556 248.445480,221.959213 246.391541,228.948608 
	C254.481049,228.948608 261.419189,229.035675 268.350708,228.859802 
	C269.458710,228.831696 271.220795,227.846283 271.517365,226.927826 
	C273.408752,221.070755 274.974335,215.108490 276.703003,208.983063 
	C267.977417,208.983063 260.385040,208.983063 252.117996,209.461899 
z"/>
<path fill="#FCFAFA" opacity="1.000000" stroke="none" 
	d="
M146.386688,184.230988 
	C140.530502,184.968582 139.446732,186.518051 139.067215,194.664871 
	C142.561050,194.856491 146.084213,195.049713 149.777863,195.252289 
	C149.404236,196.920654 149.125580,198.381165 148.747925,199.815613 
	C146.582214,208.041718 146.583145,208.180496 138.157928,208.713593 
	C134.646744,208.935760 133.805145,211.130981 133.071808,213.812088 
	C130.359863,223.727005 127.620979,233.634537 124.894516,243.536484 
	C120.193100,243.536484 115.887787,243.536484 110.843895,243.536484 
	C111.595329,240.773407 112.254059,238.303284 112.938980,235.840454 
	C117.702248,218.712692 122.456238,201.582321 127.243958,184.461411 
	C129.735031,175.553299 134.899246,171.719879 144.336761,171.686722 
	C147.955917,171.673996 151.575150,171.684647 155.739166,171.684647 
	C154.686905,176.140045 153.787140,179.949768 152.776169,184.230347 
	C150.743607,184.230347 148.781631,184.230347 146.386688,184.230988 
z"/>
<path fill="#FCF9FA" opacity="1.000000" stroke="none" 
	d="
M168.813019,185.036270 
	C169.718796,185.826981 170.687698,186.669495 170.601746,187.385330 
	C170.307922,189.832138 169.643311,192.234451 169.005722,195.182983 
	C172.607635,195.182983 175.877609,195.182983 179.775223,195.182983 
	C178.654709,200.063278 177.670334,204.350693 176.650757,208.791336 
	C175.697067,208.926300 174.898834,209.123764 174.097000,209.139786 
	C164.946625,209.322540 164.928192,209.309906 162.453125,217.925110 
	C160.387436,225.115341 158.184570,232.274429 156.419083,239.538849 
	C155.644882,242.724365 154.327087,244.015656 151.024094,243.703995 
	C148.078735,243.426086 145.086472,243.645599 141.856125,243.645599 
	C141.856125,242.612030 141.721130,241.967087 141.875824,241.401367 
	C145.997879,226.326492 150.029129,211.225113 154.347763,196.206421 
	C156.487900,188.763748 161.055542,185.409683 168.813019,185.036270 
z"/>
<path fill="#90183D" opacity="1.000000" stroke="none" 
	d="
M326.999664,64.130371 
	C313.881348,64.130371 301.262909,64.130371 288.800812,64.130371 
	C288.442871,63.669334 288.075073,63.416847 288.071411,63.159233 
	C287.863129,48.370903 286.292450,51.452320 298.960419,51.273449 
	C313.250824,51.071674 327.546326,51.226994 341.839600,51.227009 
	C343.460449,51.227013 345.081268,51.227009 346.927002,51.227009 
	C346.927002,55.670757 346.927002,59.580425 346.927002,64.130371 
	C340.349884,64.130371 333.924713,64.130371 326.999664,64.130371 
z"/>
<path fill="#8F163B" opacity="1.000000" stroke="none" 
	d="
M101.813538,209.672623 
	C100.679771,211.070602 99.598717,212.815643 98.456093,212.856934 
	C91.377731,213.112701 84.285530,212.985565 77.154884,212.985565 
	C76.786659,209.096405 78.280678,207.511719 81.926941,207.604980 
	C87.379898,207.744446 92.841888,207.548050 98.293442,207.712692 
	C99.489090,207.748810 100.657066,208.701538 101.813538,209.672623 
z"/>
<path fill="#90183D" opacity="1.000000" stroke="none" 
	d="
M252.455322,209.222473 
	C260.385040,208.983063 267.977417,208.983063 276.703003,208.983063 
	C274.974335,215.108490 273.408752,221.070755 271.517365,226.927826 
	C271.220795,227.846283 269.458710,228.831696 268.350708,228.859802 
	C261.419189,229.035675 254.481049,228.948608 246.391541,228.948608 
	C248.445480,221.959213 250.281738,215.710556 252.455322,209.222473 
z"/>
</svg>